import {NgModule} from '@angular/core';
import {TranslocoModule, TranslocoPipe} from '@jsverse/transloco';
import {MatTooltipModule} from '@angular/material/tooltip';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  declarations: [],
  imports: [
    TranslocoModule
  ],
  exports: [
    TranslocoPipe,
    MatTooltipModule,
    DirectivesModule
  ]
})
export class SharedModule { }
